import { Injectable } from '@angular/core';
import { NbToastrService } from '@nebular/theme';

import { API } from '@aws-amplify/api';
import { Store } from '@ngxs/store';
import { UtilityService } from 'src/app/core/services/utility.service';
import {
  DeleteContentSuccess,
  LoadContentSuccess,
  PostSaveComplete,
  PostSaveFail,
  UpdateContentSuccess
} from 'src/app/features/content/redux/content.actions';
import { Content } from 'src/app/models/content';
import { APIS } from 'src/app/shared/constants/api-constants';
import { AmplifyServiceBuilder } from 'src/app/shared/utils/amplify.service.builder';
import { ENVIRONMENT } from 'src/environments/environment';

@Injectable({ providedIn: 'any' })
export class ContentService {
  public allKeys: string[] = [];
  public content_api = APIS.CONTENT;
  public single_content_api = APIS.SINGLE_CONTENT;
  public type = 'content';

  constructor(private store: Store, private toastrService: NbToastrService, private utilityService: UtilityService) {}

  public loadContentAmplify(reload?) {
    API.get(this.content_api, `/${ENVIRONMENT.name}/content`, {})
      .then((response) => {
        if (reload) {
          this.toastrService.show(status, $localize`Fetching Content Complete`, {
            status: 'success'
          });
        }
        this.store.dispatch(new LoadContentSuccess(response));
      })
      .catch((error) => {
        console.error(error);
        this.toastrService.show(status, $localize`Fetching Content Failed`, {
          status: 'danger'
        });
      });
  }

  public postContentAmplify(newContent: Content) {
    const requestData = AmplifyServiceBuilder(this.content_api, false, newContent);
    API.post(this.content_api, `/${ENVIRONMENT.name}/content`, requestData)
      .then((response) => {
        this.store.dispatch(new PostSaveComplete(response, newContent));
      })
      .catch((error) => {
        this.store.dispatch(new PostSaveFail(error));
      });
  }

  public updateContentAmplify(newContent: Content) {
    const requestData = AmplifyServiceBuilder(this.content_api, false, newContent);
    API.put(this.content_api, `/${ENVIRONMENT.name}/content`, requestData)
      .then((response) => {
        this.toastrService.show(status, $localize`Updating Content Success`, {
          status: 'success'
        });
        this.store.dispatch(new UpdateContentSuccess(response));
      })
      .catch((error) => {
        console.error(error);
        const message = this.utilityService.convertErrorToMessage(error);
        this.toastrService.show(status, $localize`Updating Content Failed: ${message}`, {
          status: 'danger'
        });
      });
  }

  public deleteContentAmplify(content: Content) {
    const requestData = AmplifyServiceBuilder(this.single_content_api, false, content);
    API.del(this.single_content_api, `/${ENVIRONMENT.name}/content/${content.content_key}`, requestData)
      .then((response) => {
        this.toastrService.show(status, $localize`Deleting Content Success`, {
          status: 'success'
        });
        this.store.dispatch(new DeleteContentSuccess(content));
      })
      .catch((error) => {
        console.error(error);
        const message = this.utilityService.convertErrorToMessage(error);
        this.toastrService.show(status, $localize`Deleting Content Failed: ${message}`, {
          status: 'danger'
        });
      });
  }
}
